<script>
import request from "./request.vue";
import session from "./session.vue";

export default {

  get: async function() {
    try {
      const resp =  await request.send('https://api.japanparts.com.br/api/trade_fairs?filter[include][tradeFairImages]&filter[where][status]=1', {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error);
      return;
    }
	}
};
</script>



// WEBPACK FOOTER //
// src/api/events.vue